import { render } from "./IconMenuComponent.vue?vue&type=template&id=653314a4&ts=true"
import script from "./IconMenuComponent.vue?vue&type=script&lang=ts"
export * from "./IconMenuComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__